<template>
  <transition name="fastfade">
    <div class="loadingScreen" v-if="modelValue" @click.stop>
      <svg class="loadingScreen__svg" width="72" height="16" viewBox="0 0 72 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="4" fill="#E9041E">
          <animate attributeName="r" values="4;4;8;4;4" dur="1500ms" repeatCount="indefinite" />
        </circle>
        <circle id="c2" cx="38" cy="8" r="4" fill="#E9041E">
          <animate attributeName="r" values="4;4;8;4;4" begin="150ms" dur="1500ms" repeatCount="indefinite" />
        </circle>
        <circle id="c3" cx="64" cy="8" r="4" fill="#E9041E">
          <animate attributeName="r" values="4;4;8;4;4" dur="1500ms" begin="300ms" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    modelValue: Boolean
  },
}
</script>

<style lang="sass">
.loadingScreen
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 2000000000
  background: rgba(255,255,255,.85)
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  &_longload
    backdrop-filter: blur(2px)

  &__collapse
    transition: height 1s ease
  &__inner
    font-family: globalvars.$font6
    letter-spacing: globalvars.$onespacing
    color: colors.$gray3
    pointer-events: none
    opacity: 0
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    padding-bottom: 30px
    &-title
      font-size: 24px
      font-weight: 500
      margin-bottom: 20px
      letter-spacing: globalvars.$doublespacing
    &-content
      text-align: center
      font-size: 16px
      max-width: 550px
      padding: 0 20px
      line-height: 1.2
</style>